import { FaDownload } from '@meronex/icons/fa';
import React from 'react';
import { Link } from '@apia/theme';
import { downloadUrl } from '../../../../../utils/util';
import {
  TResponsiveTableCellRenderer,
  TResponsiveTableCellRendererProps,
} from '../types';

export type TDocNameCellRendererProps = {
  docName: string;
  docUrl: string;
};

export type TDocNameCellRenderer =
  TResponsiveTableCellRendererProps<TDocNameCellRendererProps>;

const DocNameCellRenderer: TResponsiveTableCellRenderer<TDocNameCellRendererProps> =
  React.forwardRef<HTMLTableCellElement, TDocNameCellRenderer>(
    (
      {
        cell: { children, Renderer, rendererProps, AccordionRenderer, ...cell },
        column,
        row,
        ...props
      },
      currentRef,
    ) => (
      <td
        ref={currentRef as React.RefObject<HTMLTableCellElement>}
        {...props}
        {...cell}
      >
        <Link
          className="cell__download__document"
          title={rendererProps?.docName}
          href={rendererProps?.docUrl}
          onClick={(ev) => {
            ev.preventDefault();
            if (rendererProps?.docUrl) void downloadUrl(rendererProps?.docUrl);
          }}
        >
          <FaDownload />
          {rendererProps?.docName}
        </Link>
      </td>
    ),
  );

export default DocNameCellRenderer;
